import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './HeaderGenericPrimaryLeisure.css';
import React from 'react';
import { get, getColorByTheme, getPageThemeColors, getDictionaryItem } from '../../utils';
import { Text, Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import RouterLink from '../atoms/RouterLink';
import { canUseDOM } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
var HeaderGenericPrimaryLeisure = function HeaderGenericPrimaryLeisure(_ref) {
  var rendering = _ref.rendering,
    fields = _ref.fields,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var hasPageTitle = get(fields, 'Title');
  var hasPageIntro = get(fields, 'Intro Text');
  var ctaLink = get(fields, 'ctaLink.value.href');
  var ctaLabel = get(fields, 'ctaLabel.value');
  var ref = React.useRef();
  var refMedia = React.useRef();
  var refMediaWrap = React.useRef();
  var refMediaWrapInner = React.useRef();
  // const headerLarge: string = get(fields, 'Fallback image.value.src');
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var introText = get(fields, 'Intro Text');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var dictionary = get(fields, 'data.dictionary');
  var darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  var variables = BackgroundColorHex ? {
    "--m57-header-generic-primary-leisure-bg-color": BackgroundColorHex,
    "--m57-header-generic-primary-leisure-bg-active-color": ActiveColorHex,
    "--m57-header-generic-primary-leisure-color": ColorHex
  } : {
    "--m57-header-generic-primary-leisure-bg-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m57-header-generic-primary-leisure-bg-active-color": primaryActivePageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-header-generic-primary-leisure-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var animationStart = function animationStart() {
    if (canUseDOM) {
      var mediaHeight;
      if (refMedia.current && refMediaWrapInner.current) {
        setTimeout(function () {
          mediaHeight = refMedia.current.clientHeight;
          refMediaWrap.current.style.height = "".concat(mediaHeight, "px");
          refMediaWrapInner.current.style.height = "0px";
        }, 10);
        setTimeout(function () {
          refMediaWrapInner.current.classList.add('header-media__wrap-inner--add-transition');
        }, 15);
        setTimeout(function () {
          ref.current.classList.add('info-anim-start');
          refMediaWrapInner.current.style.opacity = "1";
          refMediaWrapInner.current.style.height = "".concat(mediaHeight, "px");
        }, 50);
      }
      setTimeout(function () {
        ref.current && ref.current.classList.remove('anim-start');
        ref.current && ref.current.classList.remove('info-anim-start');
        refMediaWrap.current.style.height = "auto";
        refMediaWrapInner.current.style.height = "auto";
      }, 4000);
    }
  };
  if (!fields) {
    console.warn('HeaderGenericPrimary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-primary",
      rendering: rendering,
      mediaDesc: introText.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row header header-generic--primary anim-start",
    ref: ref
  }, /*#__PURE__*/React.createElement("button", {
    className: "header-animation-trigger",
    onClick: animationStart,
    tabIndex: -1
  }, ' ', "animation button"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media__wrap",
    ref: refMediaWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media__wrap-inner",
    ref: refMediaWrapInner
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media remove-padding-header",
    ref: refMedia
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-7"
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 header-content__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-content theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-content__main header-animation__content"
  }, hasPageTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h2 c-content__title",
    tag: "h1",
    field: hasPageTitle
  }), hasPageIntro && /*#__PURE__*/React.createElement(RichText, {
    className: "p c-content__text",
    tag: "div",
    field: hasPageIntro
  }), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-secondary c-content__btn desktop__link ",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-primary mob__link rs_skip",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  })))))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "header-animation ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle),
    removePaddingHeader: true,
    componentTabIndex: "disabled"
  }, children);
};
export var commonStyles = "c1eh0o24";
export var ltrStyles = "l1qhu04c";
export var rtlStyles = "r11ix7xt";
export default HeaderGenericPrimaryLeisure;